export const tabConstants = {
    buySellSignal: 0,
    reportDelivery: 1,
}

export const frequencyOptions = [
    {
        value: 'daily',
        text: 'component.reportSubscription.interval.daily',
    },
    {
        value: 'weekly',
        text: 'component.reportSubscription.interval.weekly',
    },
    {
        value: 'monthly',
        text: 'component.reportSubscription.interval.monthly',
    },
    {
        value: 'quarterly',
        text: 'component.reportSubscription.interval.quarterly',
    },
    {
        value: 'yearly',
        text: 'component.reportSubscription.interval.yearly',
    },
]